import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import {tableContainerStyles,tableStyles,tableCellStyles,tableRowStyles,} from "../style"

const Tabel = () => {
  return (
    <TableContainer sx={tableContainerStyles}>
      <Table sx={tableStyles} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell align="center" sx={tableCellStyles}>
              Series
            </TableCell>
            <TableCell align="center" sx={tableCellStyles}>
              YOS207
            </TableCell>
            {/* <TableCell align="right">Fat&nbsp;(g)</TableCell> */}
            <TableCell align="center" sx={tableCellStyles}>
              YOS146
            </TableCell>
            <TableCell align="center" sx={tableCellStyles}>
              YOS110
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell align="center" sx={tableRowStyles}>
              Element Max OD (mm)
            </TableCell>
            <TableCell align="center" sx={tableRowStyles}>
              207&nbsp;mm
            </TableCell>
            <TableCell align="center" sx={tableRowStyles}>
              146&nbsp;mm
            </TableCell>
            <TableCell align="center" sx={tableRowStyles}>
              110&nbsp;mm
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell align="center" sx={tableRowStyles}>
              Element Expansion Ratio
            </TableCell>
            <TableCell align="center" colSpan={3} sx={tableRowStyles}>
              ≥&nbsp;200%
            </TableCell>
            {/* <TableCell /> */}
          </TableRow>

          <TableRow>
            <TableCell align="center" sx={tableRowStyles}>
              Max Wellbore Size (in)
            </TableCell>
            <TableCell align="center" sx={tableRowStyles}>
              8.82&nbsp;in
            </TableCell>
            <TableCell align="center" sx={tableRowStyles}>
              6.3&nbsp;in
            </TableCell>
            <TableCell align="center" sx={tableRowStyles}>
              5.12&nbsp;in
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell align="center" sx={tableRowStyles}>
              Basic Pipe ID (mm)
            </TableCell>
            <TableCell align="center" sx={tableRowStyles}>
              124.26&nbsp;mm
            </TableCell>
            <TableCell align="center" sx={tableRowStyles}>
              90.12&nbsp;mm
            </TableCell>
            <TableCell align="center" sx={tableRowStyles}>
              62&nbsp;mm
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell align="center" sx={tableRowStyles}>
              Basic Pipe OD (mm)
            </TableCell>
            <TableCell align="center" sx={tableRowStyles}>
              139.7&nbsp;mm
            </TableCell>
            <TableCell align="center" sx={tableRowStyles}>
              101.6&nbsp;mm
            </TableCell>
            <TableCell align="center" sx={tableRowStyles}>
              73.02&nbsp;mm
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell align="center" sx={tableRowStyles}>
              Thread Type
            </TableCell>
            <TableCell align="center" sx={tableRowStyles}>
              5-1/2″&nbsp;LTC
            </TableCell>
            <TableCell align="center" sx={tableRowStyles}>
              14″&nbsp;NU
            </TableCell>
            <TableCell align="center" sx={tableRowStyles}>
              2-7/8″&nbsp;NU
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell align="center" sx={tableRowStyles}>
              Overall Length(mm)
            </TableCell>
            <TableCell align="center" colSpan={3} sx={tableRowStyles}>
              5000&nbsp;mm
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell align="center" sx={tableRowStyles}>
              Element Length(mm)
            </TableCell>
            <TableCell align="center" colSpan={3} sx={tableRowStyles}>
              3000&nbsp;mm
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell align="center" sx={tableRowStyles}>
              Element Material
            </TableCell>
            <TableCell align="center" colSpan={3} sx={tableRowStyles}>
              oil / water swellable
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell align="center" sx={tableRowStyles}>
              Temperature Rating(℃)
            </TableCell>
            <TableCell align="center" colSpan={3} sx={tableRowStyles}>
              120&nbsp;℃
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell align="center" sx={tableRowStyles}>
              Pressure Grade(Psi)
            </TableCell>
            <TableCell align="center" colSpan={3} sx={tableRowStyles}>
              5000
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell align="center" colSpan={4} sx={tableRowStyles}>
              Customized Design
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default Tabel;
